import React, { useState, useEffect, useContext } from "react";

import axios from "../../api/axios";

import { toast } from "react-toastify";
import PopUpPanel from "../../components/PopUpPanel/PopUpPanel";
import FormField from "../../components/forms/FormField/FormField";
import FormDropDown from "../../components/forms/DropDownList/FormDropDown";
import { CampaignContext } from "../../contexts/CampaignContext";
import { getDefaultTimeZoneListData, convertFormDateTimeTimezoneToUnixTimestamp } from "../../helpers/Dates";
import SelectUser from "../../components/SelectUser/SelectUser";
import { addStreamChannelRoute } from "../../api/routes";


const AddStreamChannel = (props) => {
    const [campaignContext, setCampaignContext] = useContext(CampaignContext);

    const [showSelectUser, setShowSelectUser] = useState(false);
    const toggleShowSelectUser = (e) => {
        if (e) {
            e.preventDefault();
        }
        setShowSelectUser(!showSelectUser);
    }
    const userSelected = (user) => {
        console.log(user);
        setStreamerHandle(user.name);
    }

    const [streamerHandle, setStreamerHandle] = useState('');
    const [streamerHandleError, setStreamerHandleError] = useState('');

    const PLATFORM_OPTIONS = [{ label: 'Twitch', value: 'twitch' }, { label: 'Amazon', value: 'amazon' }];
    const [selectedPlatformIndex, setSelectedPlatformIndex] = useState(0); // default Twitch
    const [platform, setPlatform] = useState('twitch');

    const [amazonBroadcastId, setAmazonBroadcastId] = useState('');
    const [amazonBroadcastIdError, setAmazonBroadcastIdError] = useState('');

    const [isSubmitting, setIsSubmitting] = useState(false);

    const saveStreamChannel = (e) => {
        e.preventDefault();

        if(!isSubmitting)
        {
            let formValid = true;
           if (platform === 'twitch') {
               if (streamerHandle === '') {
                    setStreamerHandleError('You need to enter your streamer\'s Twitch Handle');
                    formValid = false;
                } else {
                    setStreamerHandleError('');
                }
           } else if (platform === 'amazon') {
               if (amazonBroadcastId.trim() === '') {
                   setAmazonBroadcastIdError('You need to enter the Amazon Live Broadcast ID');
                   formValid = false;
               } else {
                   setAmazonBroadcastIdError('');
               }
           }

            if (formValid) {
                if(!isSubmitting)
                {
                    // do axios post here
                    setIsSubmitting(true);
                    axios
                    .post(addStreamChannelRoute, { 
                        campaignID:props.campaignId,
                        streamID:props.streamID,
                        // for Amazon entries provide a fixed twitchHandle so downstream code can rely on it
                        twitchHandle: platform === 'twitch' ? streamerHandle : 'amazonlive',
                        isAmazon: platform === 'amazon',
                        amazonBroadcastId: platform === 'amazon' ? amazonBroadcastId : ''
                    })
                    .then((response) =>{
                        console.log('AddStreamChannel response:', response);
                        console.log('Response data:', response.data);
                        let oldCampaignData = campaignContext.campaignData
                        oldCampaignData.streams = response.data.campaignData.streams;
                        setIsSubmitting(false);
                        setCampaignContext((oldValues) => {
                            return { ...oldValues, initialising: false, campaignData: oldCampaignData }
                        })
                        toast.success("Channel successfully added to stream");
                        props.closePanelFunc();
                    }).catch(err => {
                        setIsSubmitting(false);
                        console.error(err);
                        toast.error('Failed to add channel');
                    })
                    .catch((error) => {
                        console.error('AddStreamChannel error:', error);
                        console.error('Error response:', error.response);
                        setIsSubmitting(false);
                        toast.error("Failed to add channel to stream");
                    })
                }
                
            }
        }
    }

    return (
        <>
        {!showSelectUser &&
        <PopUpPanel closePanelFunc={props.closePanelFunc}>
            <div className="form-holder co-popup-content">
                <form id="addstream" className="form">
                    <h2>Add Channel To Stream</h2>

                    <div className="fl-row">
                        <div className="grow">
                            <FormDropDown
                                label="Platform"
                                items={PLATFORM_OPTIONS}
                                currentIndex={selectedPlatformIndex}
                                selectFunc={(e, id, item) => {
                                    e && e.preventDefault();
                                    setSelectedPlatformIndex(item.index);
                                    setPlatform(item.value);
                                }}
                                showErrors={false}
                                enabled={!isSubmitting}
                            />
                        </div>
                    </div>

                    <div className="fl-row">
                        <div className="grow">
                        {platform === 'twitch' &&
                            <FormField
                                type="text"
                                id="str_handle"
                                placeholder="Enter Twitch Handle"
                                setFunc={setStreamerHandle}
                                label="Streamer Twitch Handle"
                                error={streamerHandleError}
                                value={streamerHandle}
                            />
                        }
                        {platform === 'amazon' &&
                            <FormField
                                type="text"
                                id="amazon_broadcast_id"
                                placeholder="Enter Broadcast ID"
                                setFunc={setAmazonBroadcastId}
                                label="Amazon Live Broadcast ID"
                                error={amazonBroadcastIdError}
                                value={amazonBroadcastId}
                            />
                        }
                        </div>
                        <div>
                        {platform === 'twitch' &&
                            <button type="button" className="submit-btn" onClick={toggleShowSelectUser}>Select</button>
                        }
                        </div>
                    </div>
                    <button className={'submit-btn' + (isSubmitting ? ' button-inactive' : ' button-active')} onClick={isSubmitting ? null : saveStreamChannel}>
                        {isSubmitting ? "Adding Channel" : "Add Channel"}
                    </button>
                </form>
            </div>
        </PopUpPanel>
        }
        {showSelectUser &&
            <SelectUser closePanelFunc={toggleShowSelectUser} selectUserFunc={userSelected} twitchOnly={true} />
        }
        </>
    )
}

export default AddStreamChannel;
